
namespace SorAraBul.Definitions {

    @Serenity.Decorators.registerClass()
    export class OccupationDialog extends Serenity.EntityDialog<OccupationRow, any> {
        protected getFormKey() { return OccupationForm.formKey; }
        protected getIdProperty() { return OccupationRow.idProperty; }
        protected getLocalTextPrefix() { return OccupationRow.localTextPrefix; }
        protected getNameProperty() { return OccupationRow.nameProperty; }
        protected getService() { return OccupationService.baseUrl; }
        protected getDeletePermission() { return OccupationRow.deletePermission; }
        protected getInsertPermission() { return OccupationRow.insertPermission; }
        protected getUpdatePermission() { return OccupationRow.updatePermission; }

        protected form = new OccupationForm(this.idPrefix);
    }
}
